import instance from '@/services/repository';

const resource = 'lists';

export default {
    async get() {
        return instance.get(`${resource}`);
    },
    getSingle(listname: string) {
        return instance.get(`${resource}/${listname}`);
    },
    addList(listname: string) {
        return instance.post(`${resource}/${listname}`);
    },
    addValue(listname: string, value: string) {
        return instance.post(`${resource}/${listname}/add/${value}`);
    },
    refreshValues(listname: string, values: string[]) {
        return instance.post(`${resource}/${listname}/refreshList/`, values);
    },
    removeValue(listname: string, value: string) {
        return instance.delete(`${resource}/${listname}/remove/${value}`);
    },
};
